import template from './skillsmatrix_report.html';
import * as Utils from '../../lib/savanna_utils.js';
import tr from '../../lib/default-translator.js';

class SkillsMatrixViewModel
{
	constructor(page)
	{
		this.page = page;
		this.employee_missing_data = ko.observableArray();
		this.show_export_table = ko.observable(false);

		this.include_default = ko.observable(false),
		this.show_correct_values = ko.observable(true),
		this.current_department_id = ko.observable();
		this.selected_department = ko.observable();
		this.field_names = ko.observableArray();
		this.selected_field_name = ko.observable(null);
		this.selected_field_names = ko.observableArray([]);

		this.selected_department.subscribe((newValue) => {
			if (newValue != null)
			{
				this.current_department_id(newValue.department_id);
				this.selected_field_names([]);

				this.page.updateData();
			}
			else
			{
				this.current_department_id(null);
				this.page.updateData();
			}
		});

		this.selected_field_names.subscribe(() => {
			this.page.updateData();
		});

		this.include_default.subscribe((newText) => {
			this.page.updateData();
		});

		this.show_correct_values.subscribe((newText) => {
			this.page.updateData();
		});

		this.selected_options_text = ko.computed(() => {
			let selected_names = this.selected_field_names();
			if (!Array.isArray(selected_names)) selected_names = ko.unwrap(selected_names);
			if (selected_names.length === 0) return 'Filter by field name';
			if (selected_names.length > 3) return `${selected_names.length} Field names selected`;
			return selected_names.join(', ');
		});
	}

	toggle_field_name_selection(field_name)
	{
		if (this.selected_field_names().includes(field_name))
			this.selected_field_names.remove(field_name);
		else
			this.selected_field_names.push(field_name);
	}

	show_report_help()
	{
		Grape.dialog.open('SkillsCompetencyDataHelp', { employee_id: this.page.bindings.id });
	}

	async download_click()
	{
		let csv_string = '';
		const tables = document.querySelectorAll('#skills_matrix_report');

		tables.forEach((table, index) => {
			const rows = table.querySelectorAll('tr');

			// Add employee name as a header
			if (rows.length > 0) {
				let employee_name = rows[0].textContent.trim();
				csv_string += `${employee_name}\n\n`;
			}

			// Add column headers
			csv_string += 'Field name,Value,Valid until\n';

			// Start from second row to skip the employee name row and the header row
			for (let i = 2; i < rows.length; i++)
			{
				let cells = rows[i].querySelectorAll('td');
				if (cells.length >= 2)
				{
					let field_name = cells[0].textContent.trim();
					let value = cells[1].textContent.trim();
					let valid_till = cells.length > 2 ? cells[2].textContent.trim() : '';
					csv_string += `${field_name},${value},${valid_till}\n`;
				}
			}

			// Add a blank line between employees if there are more tables
			if (index < tables.length - 1)
				csv_string += '\n';
		});

		if (csv_string === '')
		{
			Grape.alerts.alert({type: 'info', message: tr('No data to download')});
			console.log('No data to download');
			return;
		}

		let blob = new Blob([csv_string], { type: 'text/csv;charset=utf-8;' });
		let link = document.createElement('a');

		link.href = URL.createObjectURL(blob);
		link.setAttribute('download', 'skills_matrix_data_report.csv');

		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	}
}

class SkillsMatrixPage
{
	constructor (bindings)
	{
		this.bindings = bindings;
		this.viewModel = new SkillsMatrixViewModel(this);
	}

	async init()
	{
		// check access to page
		if (await Utils.redirectOnAccessDenied('OutstandingDataReport'))
			return;

		document.title = tr('Skills and Competency Report');
		window.current_page_title(tr('Skills and Competency Report'));

	}

	async updateData()
	{
		let data = {
			department_id: this.viewModel.current_department_id()
		};
		
		if (this.viewModel.current_department_id() != null)
		{

			let res = await Grape.fetches.postJSON('/reports/fields_skills_matrix_report', data);
			if (res)
			{
				if (res.result === null)
				{
					Grape.alerts.alert({
						type: 'warning',
						title: 'Warning',
						message: `There are no educational employee fields for selected department.<br>
							Please <a href="#admin/employee_fields" id="navigate-employee-fields">add educational employee fields</a>
							to the department to be able to view this report`
					});
					
					// Add event listener to link in message
					setTimeout(() => {
						let link = document.getElementById('navigate-employee-fields');
						if (link)
						{
							link.addEventListener('click', (e) => {
								// Find the alert dialog to close after navigation 
								let alert_dialog = e.target.closest('.ps-dialog.ps-alert');
								if (alert_dialog)
								{
									// Find and click the close button
									let close_button = alert_dialog.querySelector('.ps-dialog-footer .ps-btn-default');
									if (close_button)
									{
										// Set a tiny timeout to ensure the close happens first
										setTimeout(() => {
											close_button.click();
										}, 20);
									}
								}
							});
						}
					}, 200);
				}
				else
				{
					this.viewModel.field_names(res);
				}
				this.updateReportData();
			}
		}
	}

	async updateReportData()
	{
		let data = {
			department_id: this.viewModel.current_department_id(),
			field_names: this.viewModel.selected_field_names()
		};

		let res = await Grape.fetches.postJSON('/reports/skillsmatrix_report', data);
		if (res)
		{
			if (this.viewModel.selected_field_names().length > 0)
			{
				let filtered_data = {
					e_missing_info: res.e_missing_info.map(employee => {
						return {
							...employee,
							missing_items: employee.missing_items.filter(item =>
								this.viewModel.selected_field_names().includes(item.field_name)
							)
						};
					}),
					field_names_list: res.field_names_list,
					status: res.status
				};
				this.viewModel.employee_missing_data(ko.mapping.fromJS(filtered_data));
			}
			else 
				this.viewModel.employee_missing_data(ko.mapping.fromJS(res));
		}
	}
}

export default {
	route: '[/]report/skillsmatrix',
	page_class: SkillsMatrixPage,
	template: template,
	template_filename: 'translation/skillsmatrix_report'
};
